module.exports = "dist/37f5a614fc850897d7db937c5d6b03ee.svg";